import { render, staticRenderFns } from "./PanelHeader.global.vue?vue&type=template&id=268b9f74&scoped=true&lang=pug&"
import script from "./PanelHeader.global.vue?vue&type=script&lang=ts&"
export * from "./PanelHeader.global.vue?vue&type=script&lang=ts&"
import style0 from "./PanelHeader.global.vue?vue&type=style&index=0&id=268b9f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268b9f74",
  null
  
)

export default component.exports